/**
 * Labstep
 *
 * @module components/Filter/Action/ToggleCollapse
 * @desc An action to toggle filter collapsed state
 */

import { withUiPersistent } from 'labstep-web/containers/UiPersistent';
import { ToggleCollapse } from 'labstep-web/core/ToggleCollapse';
import type React from 'react';
import type { FilterActionToggleCollapseProps } from './types';

export const FilterActionToggleCollapse: React.FC<
  FilterActionToggleCollapseProps
> = ({ toggleUiFilter, uiPersistent, filter }) => (
  <ToggleCollapse
    onClick={() => toggleUiFilter(filter.entityName, filter.name)}
    isCollapsed={
      uiPersistent.filters[filter.entityName][filter.name]!.state ===
      'collapsed'
    }
  />
);

export default withUiPersistent(FilterActionToggleCollapse);
